import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendTrendNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 14,
	viewBox: "0 0 8 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_237_14869",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 8,
		height: 14,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 14,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_237_14869)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1 5.5L4 2.5L7 5.5",
			stroke: "#7FE718",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4 4V11.5",
			stroke: "#7FE718",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})]
});
export default SvgTrendTrendNew;
